<template>
    <div class="content">
        <div class="uk-container">
            <guide-framework></guide-framework>
            <guide-idea></guide-idea>
            <guide-css></guide-css>
            <guide-javascript></guide-javascript>
            <guide-charts></guide-charts>
            <guide-api></guide-api>
            <guide-images></guide-images>
            <guide-colors></guide-colors>
            <guide-mobile></guide-mobile>
            <guide-icons></guide-icons>
            <guide-tools></guide-tools>
            <guide-community></guide-community>
        </div>
    </div>
</template>

<script>
import GuideFramework from './Frameworks'
import GuideIdea from './Idea'
import GuideCss from './Css'
import GuideJavascript from './Javascript'
import GuideCharts from './Charts'
import GuideApi from './Api'
import GuideImages from './Images'
import GuideColors from './Colors'
import GuideMobile from './Mobile'
import GuideIcons from './Icons'
import GuideTools from './Tools'
import GuideCommunity from './Community'

export default {
  components: {
    'guide-framework': GuideFramework,
    'guide-idea': GuideIdea,
    'guide-css': GuideCss,
    'guide-javascript': GuideJavascript,
    'guide-charts': GuideCharts,
    'guide-api': GuideApi,
    'guide-images': GuideImages,
    'guide-colors': GuideColors,
    'guide-mobile': GuideMobile,
    'guide-icons': GuideIcons,
    'guide-tools': GuideTools,
    'guide-community': GuideCommunity
  }
}
</script>

<style lang="sass">
    .content
        @media (min-width: 960px)
            margin-left: 246px

        .uk-icon.icon
            margin-right: 10px
</style>
